import { useContext, useState } from 'react'

import {
  Box,
  Button,
  Icon,
  IconsName,
  Text,
  ThemeColors,
} from '@fairfashion/design-system'

import { QRCodeDetailsContext } from '../../qrcode-details.context'
import * as QRCodeDetailsStyles from '../../qrcode-details.styles'
import { QRCodeDetailsMetricsFormModal } from '../QRCodeDetailsMetricsFormModal/qrcode-details-metrics-form-modal.comp'

import * as Styles from './qrcode-details-metrics.styles'

const colors: ThemeColors[] = [
  'light_blue',
  'purple',
  'warning',
  'success',
  'gray_blue',
]

export const QRCodeDetailsMetrics = () => {
  const [metricsFormModalOpen, setMetricsFormModalOpen] = useState(false)

  const { qrcode } = useContext(QRCodeDetailsContext)

  return (
    <QRCodeDetailsStyles.Card direction="column" gap={2}>
      <Box width="100%" justifyContent="space-between" alignItems="center">
        <Text fontWeight={500}>Métricas do produto</Text>
        <Button
          padding="10px 14px"
          onClick={() => setMetricsFormModalOpen(true)}
        >
          <Icon name="edit" color="white" />
          <Text color="white" size="small" fontWeight={500}>
            Editar Métricas
          </Text>
        </Button>
      </Box>

      <Box width="100%" gap={3} flexWrap="wrap">
        {qrcode?.finishedItemProfile?.metrics?.map((metric, index) => (
          <Box gap={1} key={`metric-${index}`} alignItems="center">
            <Box>
              <Styles.IconContainer color={colors[index % colors.length]}>
                <Icon name={metric.icon as IconsName} size={20} color="white" />
              </Styles.IconContainer>
            </Box>
            <Box flex={1} direction="column">
              <Text size="small">{metric.title}</Text>
              <Text size="small" color="grey_3">
                {metric.description}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>

      <QRCodeDetailsMetricsFormModal
        open={metricsFormModalOpen}
        onClose={() => setMetricsFormModalOpen(false)}
      />
    </QRCodeDetailsStyles.Card>
  )
}
